import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { api } from '../api/client'

export default function Register() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [notifyMe, setNotifyMe] = useState(false)
  const [privacyAccepted, setPrivacyAccepted] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!privacyAccepted) {
      setError('Bitte akzeptieren Sie die Datenschutzerklärung.')
      return
    }
    if (password !== confirm) {
      setError('Passwörter stimmen nicht überein.')
      return
    }
    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen haben.')
      return
    }
    setLoading(true)
    try {
      await api.post('/auth/register', { email, password, notify_me: notifyMe })
      navigate('/login', { state: { message: 'Registrierung erfolgreich. Bitte prüfen Sie Ihre E-Mails und klicken Sie den Aktivierungslink, bevor Sie sich anmelden.' } })
    } catch (err) {
      const msg = err?.message || ''
      if (msg.includes('already registered') || msg.includes('Email already')) {
        setError('Diese E-Mail ist bereits registriert.')
      } else if (msg.includes('E-Mail-Domains') || msg.includes('bestimmte E-Mail')) {
        setError('Registrierung ist nur für bestimmte E-Mail-Domains möglich.')
      } else if (msg.includes('Password') || msg.includes('8 characters')) {
        setError('Passwort muss mindestens 8 Zeichen haben.')
      } else {
        setError(msg || 'Registrierung fehlgeschlagen.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
      <div className="card-glass w-full max-w-md p-6 sm:p-8">
        <div className="flex justify-center" aria-hidden>
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500 to-pink-500 text-2xl font-bold shadow-glow">◇</div>
        </div>
        <h1 className="mt-6 text-center text-2xl font-bold text-white">
          <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Registrieren</span>
        </h1>
        <p className="mt-2 text-center text-white/60">Kostenloses Konto anlegen (Startguthaben inklusive)</p>
        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          {error && (
            <div role="alert" className="rounded-xl border border-red-500/40 bg-red-500/15 px-4 py-3 text-sm font-medium text-red-200">
              {error}
            </div>
          )}
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">E-Mail</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
              placeholder="name@beispiel.de"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">Passwort (min. 8 Zeichen)</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">Passwort bestätigen</span>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              autoComplete="new-password"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
            />
          </label>
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={privacyAccepted}
              onChange={(e) => setPrivacyAccepted(e.target.checked)}
              required
              className="mt-0.5 rounded border-white/20 bg-white/5 text-violet-500 focus:ring-violet-500/20"
            />
            <span className="text-sm text-white/80">
              Ich habe die <Link to="/datenschutz" target="_blank" rel="noopener noreferrer" className="text-violet-300 hover:underline">Datenschutzerklärung</Link> gelesen und akzeptiert.
            </span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={notifyMe}
              onChange={(e) => setNotifyMe(e.target.checked)}
              className="rounded border-white/20 bg-white/5 text-violet-500 focus:ring-violet-500/20"
            />
            <span className="text-sm text-white/80">Bei Wunsch benachrichtigen (Newsletter/Updates)</span>
          </label>
          <button type="submit" className="btn-gradient w-full min-h-[48px] py-3 text-base" disabled={loading}>
            {loading ? 'Bitte warten…' : 'Konto anlegen'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-white/70">
          Bereits Konto?{' '}
          <Link to="/login" className="text-violet-300 hover:underline">Anmelden</Link>
        </p>
      </div>
    </div>
  )
}
